import HolidaySettingsTab from './holiday-settings';

export default HolidaySettingsTab;
